import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgErrorPageIllustration = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 1433,
	height: 822,
	viewBox: "0 0 1433 822",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			width: 1432,
			height: 822,
			transform: "translate(1)",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M1076.46 370.444H1339.49C1346.52 370.444 1352.21 376.143 1352.21 383.172V438.323C1352.21 445.352 1346.52 451.05 1339.49 451.05H1076.46V370.444Z",
			fill: "#C2E2F2"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M991.609 339.808L1008.61 339.808V483.808H991.609V339.808Z",
			fill: "#004A6C"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M1008.58 339.808L1076.46 370.444V451.05L1008.58 483.808L1008.58 339.808Z",
			fill: "#7EBEE5"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 1096.61,
			y: 416.808,
			width: 9.54545,
			height: 35,
			rx: 4.77273,
			transform: "rotate(-90 1096.61 416.808)",
			fill: "#003752"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M0.608398 115.808L0.608373 706.615L991.808 483.808L991.609 339.808L0.608398 115.808Z",
			fill: "#EDF8FA"
		})
	]
});
export default SvgErrorPageIllustration;
